<template>
  <div class="success">
    <div class="statusImage">
      <div class="shieldImage">
        <span ref="shieldSuccess" class="glowSprite"></span>
      </div>
    </div>
    <div class="official">
      <span>{{ $t("success") }}</span>
      <div class="text">{{ $t("success_details") }}</div>
    </div>
  </div>
  <div class="iframeContainer border" style="height: 736px; opacity: 1">
    <div style="transform: scale(1)">
      <iframe :src="urlSrc" id="iframegame" class="iframeContent"></iframe>
    </div>
  </div>
</template>

<script>
import { gsap } from "gsap";

export default {
  name: "SuccessView",
  props: {
    lang: String,
    roundId: String,
    timestamp: String,
    tranId: String,
    env: String,
  },
  data() {
    return {
      gsapTimeline: null,
    };
  },
  mounted() {
    this.resizeIframe();
    window.addEventListener("resize", this.resizeIframe);
    this.animateImageStartSequence();
    setTimeout(() => {
      this.animateImageSequence();
    }, 1300);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.resizeIframe);
    if (this.gsapTimeline) {
      this.gsapTimeline.kill();
      this.gsapTimeline = null;
    }
  },
  computed: {
    urlSrc() {
      if (this.env === "1") {
        return `https://public.pgf-asw0zzz.com/result/?roundId=${this.roundId}&timestamp=${this.timestamp}&tranId=${this.tranId}&verify=true`;
      } else {
        return `https://public.pgssoft-games.com/result/?roundId=${this.roundId}&timestamp=${this.timestamp}&tranId=${this.tranId}&verify=true`;
      }
    },
  },
  methods: {
    animateImageSequence() {
      const el = this.$refs.shieldSuccess;
      if (!el) return;

      // GSAP timeline
      const tl = gsap.timeline({ repeat: -1, repeatDelay: 3 });
      this.gsapTimeline = tl;

      // Define the number of frames and frame dimensions
      const frameCount = 24; // Total frames in the image

      for (let i = 0; i < frameCount; i++) {
        tl.to(el, {
          duration: 0.064, // Speed of each frame
          ease: "none",
          onStart: () => {
            el.className = `shield_success_shiny_effect_${String(i).padStart(
              5,
              "0"
            )} glowSprite`;
          },
        });
      }
    },
    animateImageStartSequence() {
      const el = this.$refs.shieldSuccess;
      if (!el) return;

      // GSAP timeline
      const tl = gsap.timeline();
      this.gsapTimeline = tl;

      // Define the number of frames and frame dimensions
      const frameCount = 20; // Total frames in the image

      for (let i = 0; i < frameCount; i++) {
        tl.to(el, {
          duration: 0.064, // Speed of each frame
          ease: "none",
          onStart: () => {
            el.className = `scaleSprite shield_success_pop_up_000${String(
              i
            ).padStart(2, "0")}`;
          },
        });
      }
    },
    resizeIframe() {
      // Get the iframe container and content
      const container = document.querySelector(".iframeContainer");
      const iframeContent = document.querySelector(".iframeContent");

      // Get container dimensions (defined by the CSS as 100% width, max-width 414px, height 736px)
      const containerWidth = container.clientWidth;

      // Original iframe content size
      const originalWidth = 415; // Width in the CSS
      const originalHeight = 737; // Height in the CSS

      // Calculate scaling factor to fit the container size proportionally
      // Use the width scaling factor to maintain the aspect ratio
      const scale = containerWidth / originalWidth; // This will be used to scale both width and height

      // Apply the scaling transformation to the iframe content
      iframeContent.parentElement.style.transform = `scale(${scale})`;

      // Set the transform-origin to 0 0 to ensure proper scaling
      iframeContent.parentElement.style.transformOrigin = "0 0";

      // Adjust width and height of the container holding the iframe to ensure proper centering
      iframeContent.parentElement.style.width = `${originalWidth}px`;
      iframeContent.parentElement.style.height = `${originalHeight}px`;

      // Adjust the container height based on the scaled height of the iframe content
      container.style.height = `${originalHeight * scale - 1}px`; // Dynamically set the container height
    },
  },
};
</script>
